import { useScanRelationContext } from '../form-wrapper/relations-context.component'
import { useStyles } from '../styles'
import { DetailsForm } from './form.component'

export const DetailsStep = () => {
  const { step } = useScanRelationContext()
  const classes = useStyles()

  if (step !== 3) {
    return null
  }

  return (
    <div className={classes.sectionWrapper}>
      <div className={classes.section}>
        <DetailsForm />
      </div>
    </div>
  )
}
